namespace Areas.Reports {
    "use strict";


    //505
    export function GetCP505Dialog(a) {
     

        const Report505Dialog =
            new Areas.Dialogs.Report505Dialog(report505DialogClosing(), report505DialogRunProcess());
    }

    function report505DialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

        }
    }

    function report505DialogRunProcess() {
        return (data: any) => {            
            let projectId = data.projectId;

            let startDate = data.startDate;
            if (startDate != null) {
                startDate = moment(data.startDate).format('YYYY-MM-DD');
            }

            let endDate = data.endDate;
            if (endDate != null) {
                endDate = moment(data.endDate).format('YYYY-MM-DD');
            }

            let grouping = data.grouping;
            let ccIds = data.ccIds;
            let fundSourceIds = data.fundSourceIds;
            let subLks = data.subLks;
            let reportLevel = data.reportLevel;

            if (projectId != null) {
                const url = `/Reports/Report/Get505/${projectId}/${startDate}/${endDate}/${grouping}/${ccIds}/${fundSourceIds}/${subLks}/${reportLevel}`;
                window.open(url);
            }
        }
    }
    //123
    export function GetCP123Dialog(a) {
   
        const Report123Dialog =
            new Areas.Dialogs.Report123Dialog(report123DialogClosing(), report123DialogRunProcess());
    }

    function report123DialogRunProcess() {
        return (data: any) => {
           
            let projectId = data.projectId;

            let startDate = data.startDate;
            if (startDate != null) {
                startDate = moment(data.startDate).format('YYYY-MM-DD');
            }

            let endDate = data.endDate;
            if (endDate != null) {
                endDate = moment(data.endDate).format('YYYY-MM-DD');
            }

            let reportLevel = data.reportLevel;
            let showCost = data.showCost;
            let employeeId = data.employeeId;
            let ccIds = data.ccIds;
            let workOrderIds = data.workOrderIds;

            if (projectId != null) {
                const url = `/Reports/Report/Get123/${projectId}/${startDate}/${endDate}/${ccIds}/${workOrderIds}/${employeeId}/${reportLevel}/${showCost}`;
                window.open(url);
            }
        }
    }

    function report123DialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
        }
    }

    //309
    export function GetCP309Dialog(a) {
     
        const Report309Dialog =
            new Areas.Dialogs.Report309Dialog(report309DialogClosing(), report309DialogRunProcess());
    }

    function report309DialogRunProcess() {
        return (data: any) => {
      
            let projectId = data.projectId;
            let startDate = data.startDate;
            if (startDate != null) {
                startDate = moment(data.startDate).format('YYYY-MM-DD');
            }

            let endDate = data.endDate;
            if (endDate != null) {
                endDate = moment(data.endDate).format('YYYY-MM-DD');
            }
            let employeeId = data.employeeId;
            let ccIds = data.ccIds;
            let workOrderIds = data.workOrderIds;

            if (projectId != null) {
                const url = `/Reports/Report/Get309/${projectId}/${startDate}/${endDate}/${ccIds}/${workOrderIds}/${employeeId}`;
                window.open(url);
            }
        }
    }

    function report309DialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
        }
    }

    //309a
    export function GetCP309aDialog(a) {
     
        const Report309aDialog =
            new Areas.Dialogs.Report309aDialog(report309aDialogClosing(), report309aDialogRunProcess());
    }

    function report309aDialogRunProcess() {
        return (data: any) => {
     
            let projectId = data.projectId;
            let startDate = data.startDate;
            if (startDate != null) {
                startDate = moment(data.startDate).format('YYYY-MM-DD');
            }

            let endDate = data.endDate;
            if (endDate != null) {
                endDate = moment(data.endDate).format('YYYY-MM-DD');
            }
            let employeeId = data.employeeId;
            let ccIds = data.ccIds;
            let workOrderIds = data.workOrderIds;

            if (projectId != null) {
                const url = `/Reports/Report/Get309a/${projectId}/${startDate}/${endDate}/${ccIds}/${workOrderIds}/${employeeId}`;
                window.open(url);
            }
        }
    }

    function report309aDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
        }
    }

    //401
    export function GetCP401Dialog(a) {
      
        const Report505Dialog =
            new Areas.Dialogs.Report401Dialog(report401DialogClosing(), report401DialogRunProcess());
    }

    function report401DialogRunProcess() {
        return (data: any) => {
          
            let projectId = data.projectId;
            let startDate = data.startDate;
            if (startDate != null) {
                startDate = moment(data.startDate).format('YYYY-MM-DD');
            }

            let endDate = data.endDate;
            if (endDate != null) {
                endDate = moment(data.endDate).format('YYYY-MM-DD');
            }
            let employeeId = data.employeeId;
            let ccIds = data.ccIds;
            let workOrderIds = data.workOrderIds;

            if (projectId != null) {
                const url = `/Reports/Report/Get401/${projectId}/${startDate}/${endDate}/${ccIds}/${workOrderIds}/${employeeId}`;
                window.open(url);
            }

        }
    }

    function report401DialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
        }
    }

    //581
    export function GetCP581Dialog(a) {

        const Report505Dialog =
            new Areas.Dialogs.Report581Dialog(report581DialogClosing(), report581DialogRunProcess());
    }

    function report581DialogRunProcess() {
        return (data: any) => {
          
            let projectId = data.projectId;

            let ccIds = data.ccIds;
            let fundSourceIds = data.fundSourceIds;
            let showCost = data.showCost;


            if (projectId != null) {
                const url = `/Reports/Report/Get581/${projectId}/${ccIds}/${fundSourceIds}/${showCost}`;
                window.open(url);
            }
        }
    }

    function report581DialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
        }
    }
}

